<template>
    <!--v-container v-resize="onResize" fluid class="pa-0"-->  
    <v-layout v-resize="onResize" id="navToolbar" row wrap fluid>          
        <v-toolbar-items class="text-xs-center">
            <v-layout row wrap>
            <template v-for="(menuitem, index) in navMenu">                
                <v-flex xs4 sm4 :key="index" >
                     <v-badge 
                        v-if="(menuitem.title == 'Pedido') && ($store.state.orderItems.length > 0)"
                        right
                        overlap
                        >
                        <template v-slot:badge>
                            <span>{{$store.state.orderItems.length}}</span>
                        </template>
                        <v-btn 
                            class="btnfix"                                 
                            flat                
                            :color="menuitem.color"                                   
                            @click="navigate(menuitem.id)"
                            v-if="(menuitem.userType == 'all') || ($store.state.usuario.type == menuitem.userType)"
                            >
                        
                            <v-icon left dark>{{menuitem.icon}}</v-icon>
                            <v-flex hidden-xs-only>{{menuitem.title}}</v-flex>
                        </v-btn>
                    </v-badge>
                    <v-btn 
                        class="btnfix"                                 
                        flat                
                        :color="menuitem.color"                                   
                        @click="navigate(menuitem.id)"
                        v-else-if="(menuitem.userType == 'all') || ($store.state.usuario.type == menuitem.userType)"
                        ><v-icon left dark>{{menuitem.icon}}</v-icon>
                        <v-flex hidden-xs-only>{{menuitem.title}}</v-flex>
                    </v-btn>
                    
                </v-flex>                
            </template>                         
            </v-layout>
            
            <!--v-btn :color="catalogocolor" flat>Catálogo</v-btn>
            <v-btn :color="pedidocolor" flat>Pedido</v-btn-->            
        </v-toolbar-items>            
    <!--v-flex v-if="($store.state.usuario.type == 'Comercial') && ($store.state.customer != {})" hidden-sm-and-down class="orderData">
        {{$store.state.customer.no}} - 
        {{$store.state.customer.name}}
    </v-flex>
    <v-flex v-else hidden-sm-and-down class="orderData">
        {{$store.state.usuario.custNo}} - 
        {{$store.state.usuario.custName}}
    </v-flex-->
    </v-layout>
    <!--/v-container-->
</template>
<script>
export default {    
    name: 'toolbar',
    data(){
        return{            
            catalogocolor: '',
            pedidocolor : '',    
            windowSize: {
                x: 0,
                y: 0,
            }         
        }
    },
    methods:{   
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }            
        }      
    },
    mounted(){
        this.navMenu[0].color = this.colorSelected;
        this.navMenu[1].color = this.colornoSelected;
        this.navMenu[2].color = this.colornoSelected;
    },
    computed:{
        colorSelected: {
            get() {
                return this.$store.state.colorselected;
            }
        },
        colornoSelected: {
            get() {
                return this.$store.state.colornoselected;
            }
        },
        navMenu:{
            get() {
                return this.$store.state.navMenu;
            },
            set(value){
                this.$store.commit('setNavMenu', value)
            }
        }
    }
}
</script>
<style scoped>
#navToolbar{        
}
.orderData{
    position: relative;
    right: 15px;
    
}
.btnfix{
    min-width: 0px;
    padding: 5px;
    margin: 4px;
}
.btnfix i{
    margin: 0px;
}
</style>
